<div class="">
  <div class="modal-content">
    <div class="modal-header">
      <h4 class="modal-title">ASSIGN OPPORTUNITY</h4>
      <button type="button" class="close headerClose" (click)="close()" >&times;</button>
    </div>
    <form #theForm="ngForm" name="theForm" (ngSubmit)="confirm()">
    <div class="modal-body" style="height: 190px;">
      <div>
        <div>
          <label>From Email:</label>
          <input type="email" class="form-control" placeholder="Enter Email"  [(ngModel)]="from_email" name="fromEmail" #fromEmail="ngModel" required/>
          <div class="error" *ngIf="!fromEmail.valid && (fromEmail.touched || fromEmail.dirty) && !fromErrMsg">
            <span *ngIf="fromEmail.errors.required">Please enter the email.</span>
          </div>
          <div class="error" *ngIf="fromErrMsg">
            <span>{{fromErrMsg}}</span>
          </div>
        </div>
        <div style="padding-top: 15px;">
          <label>To Email:</label>
          <input type="email" class="form-control" placeholder="Enter Email" name="toEmail" [(ngModel)]="to_email" #toEmail="ngModel" required/>
          <div class="error" *ngIf="!toEmail.valid && (toEmail.touched || toEmail.dirty) && !toErrMsg">
            <span *ngIf="toEmail.errors.required">Please enter the email.</span>
          </div>
          <div class="error" *ngIf="toErrMsg">
            <span>{{toErrMsg}}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer" style="text-align:right">
      <button type="button" class="btn cancel_btn width100 float-left" (click)="close()">Cancel</button>
      <button type="submit" class="btn action_btn width100" [disabled]="enableValidation(theForm)">Save</button>
    </div>
  </form>
  </div>
</div>